import { render, staticRenderFns } from "./subSkillScoresZy.vue?vue&type=template&id=108d4be0&scoped=true"
import script from "./subSkillScoresZy.vue?vue&type=script&lang=js"
export * from "./subSkillScoresZy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d4be0",
  null
  
)

export default component.exports